<template>
    <div>
        <section>
            <div style="background:#F6F6F6">
                <div class="container search py-10">
                      <div class="mx-3">
                          <p class="text-3xl 2xl:text-5xl font-bold">{{ $t('MARKETPLACE.WHAT_SERVICES_DO_YOU_NEED') }}</p>
                      </div>
                    <Categories v-if="companyCategories.length || !categoriesLoading" v-model:category="selectedCategory"
                                v-model:subcategories="selectedSubcategories" @search="updateOffers" :show-first-on-init="true"/>
                    <div v-else class="flex justify-center">
                        <loader />
                    </div>
                </div>
            </div>
        </section>

        <ClientOnly>
            <NuxtPage
                    :has-searched="hasSearched"
                    :offers="offers"
                    :selected-category="selectedCategory"/>
        </ClientOnly>
        <a-i-widget/>
    </div>
</template>
<script lang="ts" setup>
import CitySuggestions from '~/components/shared/CitySuggestions.vue'
import {onMounted, ref, watch} from 'vue'
import Loader from '~/components/shared/Loader.vue'
import {useStore} from '~/stores/store'
import {UserRole} from '~/types/userRole'
import {AppEvents} from '~/types/events'
import {useAuthFetch} from '~/composables/useAuthFetch'
import {ResponseStatus} from '~/types/responseStatus'
import {useModal} from 'vue-final-modal'
import ModalProfileShow from '~/components/Modal/Profile/Show.vue'
import {replaceNationalLetters, sleep} from '~/utils'
import AIWidget from '~/components/AIWidget.vue'
import {Field} from "vee-validate";
import {storeToRefs} from "pinia";
import Categories from "../components/shared/Categories.vue";

const {t: $t} = useI18n()
useHead({
    title: $t('PAGE_TITLE.MARKETPLACE'),
})

definePageMeta({
    layout: 'base',
    role: [UserRole.CLIENT],
})

const route = useRoute()
const hasSearched = ref('')

const categoriesLoading = ref(true)
const {companyCategories, marketplaceOffers: offers, cities} = storeToRefs(useStore())
const selectedCategory = ref(null)
const selectedSubcategories = ref(new Set([]))
const {fetchCompanyCategories} = useStore()
const {$toast, $event} = useNuxtApp()
const selectedCity = ref('waw')
const init = ref(true)

watch(selectedCategory, () => {
    if (!init.value) return;
    selectedSubcategories.value.clear()
})

watch(companyCategories, ctgs => {
    if (ctgs.length) {
        selectedCategory.value = ctgs[0];
        // updateOffers()
        // $event(AppEvents.SEARCH_OFFERS)
    }
})

async function showSalesRepProfileModal(companyId) {
    const url = `/marketplace/search/${companyId}`
    const {data, error, status} = await useAuthFetch(url, {
        method: 'GET',
    })
    if (status.value === ResponseStatus.SUCCESS) {
        const {open: openAskForOfferSeller} = useModal({
            component: ModalProfileShow,
            attrs: {
                offerData: data.value,
            },
        })

        openAskForOfferSeller()
    }
}

onMounted(async () => {
    await fetchCompanyCategories()

    if (route.query.action === 'showSalesRep' && !!route.query.companyId) {
        await showSalesRepProfileModal(route.query.companyId)
    }

    if (route.params?.catId) {
        selectedCategory.value = companyCategories.value.find(
            cat => cat._id === route.params?.catId
        )
        selectedSubcategories.value = new Set(selectedCategory.value?.subcategoryId || '')
        init.value = false;
        await sleep(1000)
        $event(AppEvents.MARKETPLACE_FETCH_OFFERS)
    }

    if (!selectedCategory.value) {
        $toast.info($t('CHOOSE_CATEGORY'))
        return
    }
    const router = useRouter()
    const localePath = useLocalePath()
    let subcategoryId = '';
    selectedSubcategories.value.forEach((cat) => {
        subcategoryId += `subcategoryId[]=${cat}&`
    })

    const path = localePath(
        `/marketplace/search/${selectedCategory.value._id}?city=${selectedCity.value}&${subcategoryId}`
    )
    console.log(path)

    if (route.path === path) {
        return
    }
    // router.push(
    //     localePath({
    //         path,
    //         force: true,
    //     })
    // )
})

async function updateOffers(catData = null) {
    const router = useRouter()
    const localePath = useLocalePath()
    let subcategoryId = '';

    if (!selectedCity.value) {
        return
    }

    if (catData) {
        catData.subcategoriesIds.forEach((cat) => {
            subcategoryId += `subcategoryId[]=${cat}&`
        })

        const path = localePath(
            `/marketplace/search/${selectedCategory.value?._id}`
        )
        await router.push(
            localePath({
                path,
                query: {
                    city: selectedCity.value,
                    subcategoryId
                },
                force: true,
            })
        )
        return
    }
    selectedSubcategories.value.forEach((cat) => {
        subcategoryId += `subcategoryId[]=${cat}&`
    })

    const path = localePath(
        `/marketplace/search/${selectedCategory.value?._id}`
    )
    
    await router.push(
        localePath({
            path,
            query: {
                city: selectedCity.value,
                subcategoryId
            },
            force: true,
        })
    )
}

watch(cities, async c => {
    selectedCity.value = c.find(city => city.id === 'waw')?.id ?? c[0]?.id
    await sleep(500)
    $event(AppEvents.MARKETPLACE_FETCH_OFFERS_INIT)
}, { immediate: true })
</script>
<style lang="scss" scoped>
/* Stronka */

/* ZAPYTAJ_O_OFERTĘ */
.modal__content--top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
}

.content__top--text {
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
}

.modal__content--body {
  display: grid;
  grid-template-columns: 0.6fr 1fr 0.1fr;
  gap: 20px 20px;
  margin-bottom: 20px;
}

.modal__content--footer {
  margin: 25px 100px;
  text-align: center;
  color: #353535;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
  line-height: 29.724px;
}

.content__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.content__body--img {
  display: flex;
  justify-content: flex-end;
}

.content__body--form {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  gap: 20px;
}

.form__text {
  min-height: 200px;
  width: 100%;
  padding: 30px;
  border-radius: 20px;
  border: 1px solid #353535;
  background: #fff;
}

.modal-content--body-text p {
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 29.724px;
}

.modal-content--bottom {
  grid-area: 2 / 2 / 3 / 3;
}

.profile-header {
  border-radius: 20px;
  background: #f6f6f6;
}

/* WYBOR_SPRZEDAWCY */
.box__select {
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background: #f6f6f6;
  backdrop-filter: blur(2px);
  padding: 15px;
}

.box__select img {
  width: 85px;
  height: 85px;
}

.content__body--grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 0.3fr 0.3fr;
  gap: 10px;
  overflow-x: auto;
  height: 670px;
}

/* Stronka */
.search__content {
  display: block;
  align-items: center;
  grid-template-columns: 2fr 0.1fr;
  grid-template-rows: 1fr;
  gap: 0 0px;
  grid-template-areas: 'box-left box-right search search';
  background: #fff;
  padding:0;
}

.search__content--box {
  border-radius: 20px;
  padding: 15px 30px;
  text-align: center;
  height: 60px;
  font-size: 20px;
  color: #fff;
}

.box--orange {
  background: #ffa800;
}

.box--blue {
  background: #3870ff;
}

/*.box--active {
  outline: 5px solid #3870ff;
  outline-offset: 3px;
}*/
.search__content--bar {
  grid-area: search;
}

.bar__content {
  display: flex;
  gap: 15px;
}

.bar__content--search {
  border-radius: 20px;
  border: 1px solid #ffffff;
  background: #fff;
  width: 100%;
  padding: 20px;
  font-weight: 700;
  font-size: 14px;
}

.bar__content--button {
  border: 1px solid #353535;
  background: #353535;
  padding: 0 35px;
  border-radius: 20px;
}

.result__content {
  padding: 0 150px 100px 150px;
}

.content__top {
  margin: 80px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.content__top--btn {
  background: #3870ff;
  gap: 10px;
}

.result__content--list {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.content__top p {
  font-size: 30px;
  font-style: normal;
  line-height: 29.724px;
}

.content__box {
  display: grid;
  grid-template-columns: 0.5fr 1fr 1fr 1fr;
  grid-template-rows: 0.5fr 0.5fr;
  gap: 10px 20px;
  grid-template-areas:
    'img info info result'
    'img btn-profile btn-web btn-ask';
  border-radius: 20px;
  border: 1px solid #353535;
  background: #fff;
  padding: 20px;

  .btn {
    align-self: center;
  }
}

.content__box--img {
  grid-area: img;
}

.content__box--info {
  grid-area: info;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 15px;
  margin-bottom: 10px;
}

.btn-profile {
  grid-area: btn-profile;
  border-radius: 20px;
  justify-content: space-around;
  color: #353535;
  background: #f6f6f6;
}

.btn-web {
  grid-area: btn-web;
  border-radius: 20px;
  background: #f6f6f6;
  justify-content: space-around;
  color: #353535;
}

.btn-ask {
  grid-area: btn-ask;
  border-radius: 20px;
  background: #353535;
  gap: 15px;
}

.active {
  background: #3870ff;
  color: #fff;
}

.content__box--result {
  grid-area: result;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-bottom: 10px;
  align-items: flex-end;
}

@media (max-width: 1024px) {
  .result__content {
    padding: 0 60px 100px 60px;
  }
}

@media (max-width: 768px) {
  .lang-switcher {
    display: none;
  }
  .search__content {
    grid-template-areas:
      'box-left box-right'
      'search search';
    gap: 15px 0px;
    grid-template-columns: 1fr;
  }
  .bar__content--search {
    padding: 10px;
  }
  .bar__content--button {
    padding: 0 14px;
    margin-left: -50px;
  }
  .content__top {
    margin: 15px 0;
    gap: 10px 0;
    flex-direction: column;
  }
  .content__top p {
    font-size: 16px;
  }
  .search__content--box {
    height: 75px;
  }
  .result__content {
    padding: 0 15px 25px 15px;
  }
  .content__box {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 0.5fr 0.5fr;
    gap: 10px 10px;
    grid-template-areas:
      'img info info btn-profile'
      'img btn-web btn-ask btn-ask';
    padding: 7px;

    &--info {
      gap: 5px;
    }

    &--result {
      display: none;
    }
  }
}
</style>
